import type { ComponentType } from 'react'
import {
  IconAdmin,
  IconBuilding,
  IconDashboard,
  IconExport,
  IconImport,
  IconMoney,
  IconPlane,
  IconSettings,
  IconShield,
  IconShip,
} from '@/components/Icon'
import { SECOES, type ItemTela } from '@/lib/telas'

/**
 * Árvore de navegação da sidebar.
 *
 * A **estrutura** (rótulos, rotas, hierarquia) vive em `lib/telas.ts`, sem React.
 * Aqui só resolvemos os ícones. Essa separação existe para que as permissões,
 * que derivam do mesmo catálogo, possam ser testadas fora do navegador.
 *
 * No sistema antigo a sidebar era o resultado de três forças brigando: o React
 * renderizava 8 itens, o `nav_submenu.js` escondia 6 deles via `HIDE_HREFS`, e
 * 4 módulos injetavam outros 7 com `appendChild` dentro de `setInterval`.
 * Aqui é uma estrutura declarativa só, sem injeção e sem loop de vigilância.
 */

const ICONES: Record<string, ComponentType<{ className?: string }>> = {
  dashboard: IconDashboard,
  import: IconImport,
  export: IconExport,
  ship: IconShip,
  shield: IconShield,
  building: IconBuilding,
  money: IconMoney,
  plane: IconPlane,
  settings: IconSettings,
  admin: IconAdmin,
}

export type NavItem = ItemTela

export interface NavSection {
  label: string
  to: string
  icon: ComponentType<{ className?: string }>
  adminOnly?: boolean
  children?: NavItem[]
}

export const NAV: NavSection[] = SECOES.map((s) => ({
  label: s.label,
  to: s.to,
  icon: ICONES[s.icone] ?? IconDashboard,
  adminOnly: s.adminOnly,
  children: s.children,
}))

export { ROTULOS } from '@/lib/telas'
